import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery
} from '@mui/material';
// import { useTheme } from '@mui/material/style';

/**
 * @typedef Props
 * @property {{action: (e) => void, text: string}[]} buttons
 * @property {string} text
 * @property {string} title
 * @property {boolean} isOpen
 * @property {() => void} onClose
 */

/**
 *
 * @param {Props} param0
 */
export default function QuestionDialog({ buttons, text, title, isOpen, onClose }) {
  //   const theme = useTheme();
  //   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const id = `${title.replace(' ', '_')}dialog`;
  return (
    <Dialog open={isOpen} onClose={() => onClose()} aria-labelledby={id}>
      <DialogTitle id={id}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {buttons.map((button, index) => (
          <Button onClick={button.action} autoFocus={!index}>
            {button.text}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}
